module.exports = __webpack_public_path__ + "img/3.630452f5.jpg";